import React from "react";
import DataLakePageNavigation from "data-lake/components/DataLakePageNavigation";
import { DocumentTitle, PageHeader, Spinner } from "components/common";
import { Row, Col } from "components/bootstrap";
import DocsHelper from "util/DocsHelper";
import useDataLakeBackends from "data-lake/data-lake-backend-config/hooks/useDataLakeBackends";
import useDataLakeConfig from "data-lake/configurations/hooks/useDataLakeConfig";
import DataLakeConfigForm from "data-lake/configurations/DataLakeConfigForm";
const DataLakeConfigPage = () => {
  const { data: backendsList, isInitialLoading: isLoadingBackends } = useDataLakeBackends({ enabled: true });
  const { data: config, isInitialLoading: isLoadingCurrentConfig } = useDataLakeConfig();
  if (isLoadingBackends || isLoadingCurrentConfig) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Data Lake Configuration" }, /* @__PURE__ */ React.createElement(DataLakePageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: "Data Lake Configuration",
      documentationLink: {
        title: "Data Lake documentation",
        path: DocsHelper.PAGES.DATA_LAKE
      }
    },
    /* @__PURE__ */ React.createElement("span", null, "Manage Data Lake configuration")
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(DataLakeConfigForm, { backends: backendsList, config }))));
};
export default DataLakeConfigPage;
